import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Excluir rutas públicas
  if (
    req.url.includes('/auth/health') ||
    req.url.includes('firebaseapp.com') ||
    req.url.includes('/admin/system/status') ||
    req.url.includes('/admin/system/logout-epoch') ||
    req.url.includes('/admin/system/feature-flags/public')
  ) {
    return next(req);
  }

  return from(authService.getIdToken()).pipe(
    switchMap(token => {
      if (token) {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next(authReq);
      }
      return next(req);
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Token expirado o inválido
        authService.logout();
        router.navigate(['/login'], { 
          queryParams: { reason: 'session_expired' } 
        });
      } else if (error.status === 403) {
        // Sin permisos
        router.navigate(['/unauthorized']);
      }
      return throwError(() => error);
    })
  );
};

